//开发地址
//export const interfaceUrl='https://localhost:44327/';

//帮助文档地址--开发地址
//export const helperUrl = 'http://localhost:8082/';

//生产地址
 export const interfaceUrl='http://139.155.137.144:8880/';

//帮助文档地址--生产地址
 export const helperUrl = 'http://139.155.137.144:8883/'
